import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import api from "../common/Axios";
import { useNavigate } from "react-router-dom"; // Add this import for navigation

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(localStorage.getItem("token"));
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const loggedInValidationInterval = 5 * 60 * 1000;

  useEffect(() => {
    validateToken();

    const interval = setInterval(() => {
      validateToken();
    }, loggedInValidationInterval);

    return () => clearInterval(interval);
  }, [navigate]);

  const validateToken = async () => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const response = await api.post("/api/v1/auth/validate_user", {
          token,
        });
        const isTokenValid = response.data;

        if (isTokenValid) {
          setAuth(token);
          setIsLoggedIn(true);
        } else {
          setAuth(null);
          setIsLoggedIn(false);
          localStorage.clear();
        }
      } catch (error) {
        console.error("Token validation error", error);
        setAuth(null);
        setIsLoggedIn(false);
        localStorage.clear();
      }
    } else {
      setIsLoggedIn(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await api.post("/api/v1/auth/login", {
        email,
        password,
      });
      const token = response.data.token;

      localStorage.setItem("token", token);
      localStorage.setItem("name", response.data.name);
      localStorage.setItem("email", response.data.email);
      setIsLoggedIn(true);

      setAuth(token);
      return response;
    } catch (error) {
      setIsLoggedIn(false);
      console.error("Login error", error);
    }
  };

  const signup = async (email, password, name, otp, referralCode = "") => {
    try {
      const requestBody = {
        email,
        password,
        name,
        otp,
      };

      if (referralCode) {
        requestBody.referralCode = referralCode;
      }

      const response = await api.post("/api/v1/auth/signup", requestBody);
      const token = response.data.token;

      localStorage.setItem("token", token);
      localStorage.setItem("name", response.data.name);
      localStorage.setItem("email", response.data.email);
      setIsLoggedIn(true);

      setAuth(token);
      return response;
    } catch (error) {
      console.error("Signup error", error);
      setIsLoggedIn(false);
    }
  };

  const logout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setAuth(null);
  };

  const googleLogin = async (token, referralCode = null) => {
    try {
      const requestBody = { token };
      if (referralCode) {
        requestBody.referralCode = referralCode;
      }

      const response = await api.post("/api/v1/auth/google", requestBody);
      const authToken = response.data.token;

      localStorage.setItem("token", authToken);
      localStorage.setItem("name", response.data.name);
      localStorage.setItem("email", response.data.email);
      setIsLoggedIn(true);

      setAuth(authToken);
      return response;
    } catch (error) {
      console.error("Google login error", error);
      setIsLoggedIn(false);
    }
  };

  return (
    <AuthContext.Provider
      value={{ auth, login, signup, logout, googleLogin, isLoggedIn }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
